import { ParamsType } from 'rcx_adapter';
import i18n from 'rcx_i18n';

import { BaseLog } from './BaseLog';
import { ServiceNowEntity } from '../../enums';
import { formatDate, formatUTCDate } from '../../utils/timeFormat';
import type { SNSaveLogOptions } from '../ServiceNowAdapter.interface';

const EntityMap = {
    Account: 'account',
    Contact: 'contact',
    Consumer: 'consumer',
    Case: 'u_case',
    CaseTask: 'u_case_task',
};

export class InteractionLog extends BaseLog {
    private getInteractionByCallIds(ids: string[]) {
        return this.dataFetch.getInteractionByCallIds(ids);
    }

    private updateInteraction(id: string, args: { [k: string]: any }) {
        return this.dataFetch.updateInteraction(id, args);
    }

    private async openInteraction(params: { [k: string]: any }, paramsType: ParamsType) {
        let sys_id = '-1';
        if (paramsType === ParamsType.CALL) {
            const id = params?.u_call_id || '';
            const data = await this.getLogByCallIds([id]);
            const result = data?.result || [];
            if (result.length > 0) {
                sys_id = result[0].sys_id;
                this.updateInteraction(sys_id, params);
            }
        }
        const query = Object.entries(params || {})
            .map(([key, value]) => `${key}=${value}`)
            .join('^');
        this.adapter.openFrameOpenServiceNowForm(
            ServiceNowEntity.INTERACTION,
            `sys_id=${sys_id}&sysparm_query=${query}`
        );
    }

    public async saveLog({ paramsType, storageLogData }: SNSaveLogOptions) {
        const {
            type,
            whoId,
            whoType,
            RCX_Disposition,
            callType,
            subject,
            description,
            phone,
            whatId,
            whatType,
            RCX_Digital_Type,
            Call_UUID,
            callDurationInSeconds,
            Call_Recording,
            Call_Transcript,
            Call_HandleTime,
            Call_Queue,
            summary,
            leadName,
        } = storageLogData;

        const dispositionPart = RCX_Disposition ? i18n.t('common.disposition', { disposition: RCX_Disposition }) : '';
        const notePart = description ? i18n.t('common.note', { notes: description }) : '';
        const leadNamePart = leadName ? i18n.t('common.lead_name', { leadName }) : '';
        const summaryPart = summary ? i18n.t('common.summary', { summary }) : '';
        const digitalTypePart = RCX_Digital_Type
            ? i18n.t('common.digital_type', { channelType: RCX_Digital_Type })
            : '';
        const chat_summary = [dispositionPart, notePart, leadNamePart, summaryPart, digitalTypePart]
            .filter(Boolean)
            .join('\n');
        const params: any = {
            type,
            chat_summary,
            short_description: typeof subject === 'string' ? subject : '',
            [EntityMap[whoType as keyof typeof EntityMap]]: whoId,
            [EntityMap[whatType as keyof typeof EntityMap]]: whatId,
            u_call_id: Call_UUID,
            duration: formatUTCDate(new Date(callDurationInSeconds * 1000)),
            u_phone_number: phone || '',
            u_call_type: callType || null,
            recording_url: Call_Recording || '',
            u_transcript_url: Call_Transcript || '',
            u_start_time: paramsType === ParamsType.CALL ? formatDate(new Date(Call_HandleTime)) : '',
            u_end_time: callDurationInSeconds
                ? formatDate(new Date(Call_HandleTime + callDurationInSeconds * 1000))
                : '',
            u_call_queue: paramsType === ParamsType.CALL ? Call_Queue : '',
        };

        this.openInteraction(params, paramsType);
    }

    public getLogByCallIds(ids: string[]) {
        return this.getInteractionByCallIds(ids);
    }

    public viewLog(sys_id: string) {
        this.adapter.openFrameOpenServiceNowFormBySysId(sys_id, ServiceNowEntity.INTERACTION);
    }
}
